export default "__VITE_ASSET__Du4kWBV7__"